import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { CommunityPageComponent } from './pages/community-page/community-page.component';
import { PrivacyPageComponent } from './pages/privacy-page/privacy-page.component';
import { UserAgreementPageComponent } from './pages/user-agreement-page/user-agreement-page.component';
import { TrendingPageComponent } from './pages/trending-page/trending-page.component';
import { MarketingArticlePageComponent } from './pages/marketing-article-page/marketing-article-page.component';
import { UserProfilePageComponent } from './pages/profile/user-profile-page/user-profile-page.component';
import { UserProfileSeatsPageComponent } from './pages/profile/user-profile-seats-page/user-profile-seats-page.component';
import { UserProfileInfoPageComponent } from './pages/profile/user-profile-info-page/user-profile-info-page.component';
import { UserProfileAffiliatePageComponent } from './pages/profile/user-profile-affiliate-page/user-profile-affiliate-page.component';
import { UserProfileAffiliateWithdrawalPageComponent } from './pages/profile/user-profile-affiliate-withdrawal-page/user-profile-affiliate-withdrawal-page.component';
import { UseFlowPageComponent } from './pages/yun-login/use-flow-page/use-flow-page.component';
import { AigcStepComponent } from './components/yun-login/aigc-step/aigc-step.component';
import { UserProfileFormPageComponent } from './pages/profile/user-profile-form-page/user-profile-form-page.component';
import { HelpingPageComponent } from './pages/helping/helping-page/helping-page.component';
import { HelpingDetailPageComponent } from './pages/helping/helping-detail-page/helping-detail-page.component';
import { HelpingTotalPageComponent } from './pages/helping/helping-total-page/helping-total-page.component';
import { HelpingDetailArticlePageComponent } from './pages/helping/helping-detail-article-page/helping-detail-article-page.component';
import { UserProfileFleetPageComponent } from './pages/profile/user-profile-fleet-page/user-profile-fleet-page.component';
import { UserProfileFleetHistoryBoardPageComponent } from './pages/profile/user-profile-fleet-history-board-page/user-profile-fleet-history-board-page.component';
import { PopcornLandingPageComponent } from './pages/popcorn/popcorn-landing-page/popcorn-landing-page.component';
import { PopcornAfterPageComponent } from './pages/popcorn/popcorn-after-page/popcorn-after-page.component';
import { PopcornBeforePageComponent } from './pages/popcorn/popcorn-before-page/popcorn-before-page.component';
import { CooperatePageComponent } from './pages/cooperate-page/cooperate-page.component';
import { MidjourneyComponent } from './pages/midjourney/midjourney.component';
import { BusinessPageComponent } from './pages/business-page/business-page.component';
import { UserProfileWorkorderPageComponent } from './pages/profile/user-profile-workorder-page/user-profile-workorder-page.component';
import { InitWorkorderPanelComponent } from './components/profile/workorder/init-workorder-panel/init-workorder-panel.component';
import { CreateWorkorderPanelComponent } from './components/profile/workorder/create-workorder-panel/create-workorder-panel.component';
import { WorkorderDetailCardComponent } from './components/profile/workorder/workorder-detail-card/workorder-detail-card.component';
import { SelectedPageComponent } from './pages/selected-page/selected-page.component';
import { UserProfileFleetGrokPageComponent } from './pages/profile/user-profile-fleet-grok-page/user-profile-fleet-grok-page.component';
import { SalesIntroductionPageComponent } from './pages/sales-introduction-page/sales-introduction-page.component';
import { UserProfileOrderPageComponent } from './pages/profile/user-profile-order-page/user-profile-order-page.component';
import { UserProfileOrderRefundPageComponent } from './pages/profile/user-profile-order-refund-page/user-profile-order-refund-page.component';
const routes: Routes = [
  {
    path: '',
    component: MainPageComponent,
    children: [
      {
        path: '',
        component: SelectedPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'buy',
        component: HomePageComponent,
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'about',
        component: AboutPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'community',
        component: CommunityPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'privacy',
        component: PrivacyPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'agreement',
        component: UserAgreementPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'trending',
        component: TrendingPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'helping',
        component: HelpingPageComponent,
        children: [
          {
            path: '',
            component: HelpingTotalPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'detail/:tag',
            component: HelpingDetailPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'detail/:tag/p/:p/article/:article',
            component: HelpingDetailArticlePageComponent,
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'marketing/article/:id',
        component: MarketingArticlePageComponent,
        pathMatch: 'full',
      },
      {
        path: 'user/profile',
        component: UserProfilePageComponent,
        children: [
          {
            path: '',
            component: UserProfileInfoPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'seats',
            component: UserProfileSeatsPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'affiliate',
            component: UserProfileAffiliatePageComponent,
            pathMatch: 'full',
          },
          {
            path: 'affiliate/withdrawal',
            component: UserProfileAffiliateWithdrawalPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'orders',
            component: UserProfileOrderPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'orders/refund',
            component: UserProfileOrderRefundPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'form',
            component: UserProfileWorkorderPageComponent,
            children: [
              {
                path: '',
                component: InitWorkorderPanelComponent,
                pathMatch: 'full',
              },
              {
                path: 'create',
                component: CreateWorkorderPanelComponent,
                pathMatch: 'full',
              },
              {
                path: 'workorder',
                component: WorkorderDetailCardComponent,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'fleet',
            component: UserProfileFleetPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'grok',
            component: UserProfileFleetGrokPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'history/board',
            component: UserProfileFleetHistoryBoardPageComponent,
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'cooperate',
        component: CooperatePageComponent,
        pathMatch: 'full',
      },
      {
        path: 'sales-introduction',
        component: SalesIntroductionPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'business',
        component: BusinessPageComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'chatgpt-course',
    component: UseFlowPageComponent,
    children: [
      {
        path: '',
        component: AigcStepComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'popcorn',
    component: PopcornLandingPageComponent,
    children: [
      {
        path: '',
        component: PopcornBeforePageComponent,
        pathMatch: 'full',
      },
      {
        path: 'after',
        component: PopcornAfterPageComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'midjourney',
    component: MidjourneyComponent,
    children: [],
  },

  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
